// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__ljyrt","label":"Labeled_label__3II3u","divider":"Labeled_divider__hRrnt"};